<script setup>
const { $localApi } = useNuxtApp();

const modalStore = useModalStore();
const userStore = useUserStore();

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
  remind: {
    type: Boolean,
    required: true,
  },
  gradientStyle: {
    type: Boolean,
    default: false,
  },
});

const active = ref(props.remind);

async function handleReminder(remind, id) {
  if (!userStore.IS_AUTHORIZED) {
    modalStore.SHOW_MODAL({ component: 'MoleculeModalNeedAuth' });

    return;
  }

  const { data: reminded, error } = await $localApi.post(`/content/${id}/remind`, {
    query: { remind: !remind },
  });

  if (error.value) {
    useNotificationStore().ADD({
      type: 'error',
      title: 'Oops...',
      message: 'An error occurred. Please try again later.',
    });

    return;
  }

  if (reminded.value.remindedByUser) {
    modalStore.SHOW_MODAL({
      component: 'MoleculeModalEventReminderAdded',
    });
  } else {
    modalStore.SHOW_MODAL({
      component: 'MoleculeModalEventReminderRemoved',
    });
  }

  active.value = !active.value;
}
</script>

<template>
  <button type="button" @click="handleReminder(active, id)">
    <slot :active="active">
      <MoleculeNuxtIcon
        name="player/reminder"
        class="size-full shrink-0 fill-transparent"
        :class="{
          'stroke-white': !active && !gradientStyle,
          'fill-white ': active && !gradientStyle,

          'stroke-[url(#gradient)]': !active && gradientStyle,
          'stroke-[url(#gradient)] [&>svg>path]:fill-[url(#gradient)]': active && gradientStyle,
        }"
      />
    </slot>
  </button>
</template>

<style lang="scss" scoped>
.custom-gradient::before {
  border-radius: 20px;
}
</style>
